export const getColors = (isDay: boolean) => ({
  bg: isDay ? '#F5F5F5' : '#141414',
  topNavBg: isDay ? '#262626' : '#141414',
  navbarBg: isDay ? 'white' : '#141414',
  text: isDay ? '#262626' : '#FFFFFF',
  textSecondary: isDay ? '#727272' : '#b1b1b1',
  projectsBg: isDay ? '#F0F0F0' : '#262626',
  navBorder: isDay ? '#f0f0f0' : '#262626',
  border: isDay ? '#BFBFBF' : '#434343',
  borderTopNav: '#595959',
  colorPrimary: isDay ? '#00A8A7' : '#73e2da',
  optionSelect: isDay ? '#e6f4ff' : '#303030',
  colorPrimary2: '#00A8A7',
  waterOil: '#3c85fa',
  gasOil: '#fa3c3c',
  placeholder: isDay ? 'rgba(0,0,0,0.25)' : 'rgba(255, 255, 255, 0.25)'
});

// Design-system emerald-zinc scale (see src/design-system/tokens/tokens.css).
// Ordered to maximise contrast between adjacent series; light (50/100) and
// near-black (950) steps are omitted so curves stay visible on either theme.
export const emeraldZincPalette = [
  '#303B35', // 700
  '#A7B7AF', // 400
  '#677E72', // 500
  '#0E110F', // 900
  '#C7D1CC', // 300
  '#4A5B52', // 600
  '#1B211E', // 800
  '#E0E6E3'  // 200
];

export const dropdownStyle = (isDay: boolean) => ({
  backgroundColor: isDay ? 'white' : '#141414',
  color: isDay ? 'black' : 'white'
});
